import React, { Component, Fragment } from "react"
import Async from "react-select"
import Field from "../../Common/Field/Field"
import Button from "../../Buttons/Button"
import moment from "moment"

export default class ProcessUpdate extends Component {
  state = {
    tempState: {
      date: JSON.stringify(new Date())
    },
    // statusOption: [
    //   { label: "CANCEL", value: "CANCEL" },
    //   { label: "COMPLETED", value: "COMPLETED" },
    //   { label: "IN PROCESS", value: "INPROCESS" },
    //   { label: "PENDING", value: "PENDING" }
    // ]
  }

  componentWillMount() {
    const {
      _id,
      assignedTo,
      toggle,
      STATUS,
      processUpdates,
      assignedToList,
      disabled
    } = this.props
    this.setState({
      _id,
      assignedTo,
      toggle,
      processUpdates,
      STATUS,
      assignedToList,
      disabled
    })
  }

  componentWillReceiveProps(nextProps) {
    const {
      _id,
      assignedTo,
      toggle,
      STATUS,
      processUpdates,
      assignedToList,
      disabled
    } = nextProps

    this.setState({
      _id,
      assignedTo,
      toggle,
      processUpdates,
      assignedToList,
      STATUS,
      disabled
    })
  }

  render() {
    const { toggle, STATUS, processUpdates, disabled } = this.state
    const { permissions, action } = this.props
    let gvnAllPermit, length = Object.keys(permissions).length

    let j = 0
    Object.keys(permissions).forEach((x) => {
      let keyname1 = x === "garmentTechnologist" ? "garmentTech" : x === 'qc' ? "QC" : x === 'signOff' ? 'signoff' : x
      if (permissions[keyname1].web.create || permissions[keyname1].web.edit) {
        j++
        if (j == length) {
          gvnAllPermit = true
        }
      }
    })

    return (
      <Fragment>
        {gvnAllPermit && !disabled && <div>
          <Button
            type="save"
            buttonName="Click to complete all"
            onClick={() => this.props.completeAllHandler("COMPLETED")}
            disabled={true}
          />
          <Button
            type="save"
            buttonName="Click to Cancel all"
            onClick={() => this.props.completeAllHandler("CANCEL")}
          />
        </div>}
        <div className="col-md-12 mt-3">
          <table class="table table-fixed">
            <thead>
              <tr class="bg-color">
                <th width="10" className="text-left" />
                <th width="25">Assigned To</th>
                <th width="18">ETA Date</th>
                <th width="18">Status</th>
                <th width="18">Comments</th>
                <th width="19" />
                <th width="10">Completed Date</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(toggle).map((keyname, i) => {
                let keyname1 = keyname === "garmentTechnologist" ? "garmentTech" : keyname === 'qc' ? "QC" : keyname === 'signOff' ? 'signoff' : keyname
                let permit = permissions[keyname1].web.edit || permissions[keyname1].web.view || permissions[keyname1].web.create

                if (toggle[keyname] &&
                  ((permissions[keyname1].web.view && action === "view") ||
                    (permissions[keyname1].web.create && action === "add") ||
                    (permissions[keyname1].web.edit && action === "edit"))
                ) {
                  return (
                    <tr className="border-bottom-style" key={i}>
                      <td className="text-left">
                        <label className="uppercase-text">
                          {keyname == "garmentTechnologist"
                            ? "Garment Tech"
                            : keyname === 'qc' ? 'GRADING' : keyname}
                        </label>
                      </td>
                      <td>
                        <div className="custom-async-select">
                          <Async
                            name="assignedTo"
                            value={
                              this.state.processUpdates[keyname].assignedTo
                            }
                            onChange={value =>
                              this.props.updateProcessUpdate(
                                "assignedTo",
                                value,
                                keyname
                              )
                            }
                            placeholder="AssignedTo"
                            options={this.state.assignedToList}
                          />
                        </div>
                      </td>
                      <td>
                        <Field
                          isFormGroup={false}
                          inputType="date"
                          inputName="ETA"
                          value={this.state.processUpdates[keyname].ETA}
                          onChange={(name, value) =>
                            this.props.updateProcessUpdate(name, value, keyname)
                          }
                          disabled={this.state.disabled}
                        />
                      </td>
                      <td>
                        <Field
                          isFormGroup={false}
                          inputType="select"
                          inputName="status"
                          value={this.state.processUpdates[keyname].status}
                          options={STATUS}
                          onChange={(name, value) =>
                            this.props.updateProcessUpdate(name, value, keyname)
                          }
                          disabled={this.state.disabled}
                        />
                      </td>
                      <td>
                        <Field
                          isFormGroup={false}
                          inputType="text"
                          inputName="comments"
                          value={this.state.processUpdates[keyname].comments}
                          options={this.state.statusOption}
                          disabled={this.state.disabled}
                          onChange={(name, value) =>
                            this.props.updateProcessUpdate(name, value, keyname)
                          }
                        />
                      </td>
                      <td>
                        <button
                          disabled={this.state.disabled}
                          type="button"
                          class="primary"
                          name="button"
                          onClick={() => {
                            this.props.updateProcessUpdate(
                              "processDate",
                              new Date(),
                              keyname
                            )
                            this.props.updateProcessUpdate(
                              "status",
                              "COMPLETED",
                              keyname
                            )
                          }}
                        >
                          Completed
                        </button>
                      </td>
                      <td>
                        {/* {console.log(
                          this.state.processUpdates[keyname].processDate,
                          this.state.processUpdates[keyname]
                        )} */}
                        {this.state.processUpdates[keyname].processDate !==
                          null &&
                          this.state.processUpdates[keyname].status ===
                          "COMPLETED"
                          ? moment(
                            this.state.processUpdates[keyname].processDate
                          ).format("DD MMM YYYY")
                          : ""}
                      </td>
                    </tr>
                  )
                }
              })}
            </tbody>
          </table>
        </div>
        {
          gvnAllPermit && !disabled && <div className="col-md-12 text-center profile-btn">
            <Button
              buttonType="save"
              buttonName="save"
              onClick={this.props.ProcessUpdates}
            />
          </div>
        }

      </Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/ProcessUpdate/index.js